import React, { useState, useEffect } from "react";
import PopupWin from "../../../../../components/PopupWin";

const AddMappingModal = ({ visible, onClose, onConfirm, existingNames }) => {
  const [newName, setNewName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Reset and set default name when modal opens
  useEffect(() => {
    if (visible) {
      // Generate default name suggestion
      let counter = 1;
      let suggestedName = `Mapping ${counter}`;

      while (existingNames.includes(suggestedName)) {
        counter++;
        suggestedName = `Mapping ${counter}`;
      }

      setNewName(suggestedName);
      setErrorMessage("");
    }
  }, [visible, existingNames]);

  const handleNameChange = (e) => {
    const value = e.target.value;

    // Limit to 99 characters
    if (value.length > 99) {
      return;
    }

    setNewName(value);

    // Check for unique name
    if (value.trim() === "") {
      setErrorMessage("");
    } else if (existingNames.includes(value.trim())) {
      setErrorMessage("This name already exists. Please choose a different name.");
    } else {
      setErrorMessage("");
    }
  };

  const handleConfirm = () => {
    const trimmedName = newName.trim();

    if (trimmedName === "") {
      return; // Button should be disabled
    }

    if (existingNames.includes(trimmedName)) {
      setErrorMessage("This name already exists. Please choose a different name.");
      return;
    }

    onConfirm(trimmedName);
  };

  const isNameValid = newName.trim() !== "" && !existingNames.includes(newName.trim());

  return (
    <PopupWin
      visible={visible}
      onClose={onClose}
      hideClose={false}
      popupStyle={{
        width: "427px",
        minHeight: "250px",
        padding: 0,
        background: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
      }}
      contentStyle={{
        padding: "40px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <h2 className="add-mapping-modal-title">Create New Field Mapping</h2>
      <p className="add-mapping-modal-description">
        Enter a name for your new field mapping profile.
      </p>

      <div className="add-mapping-modal-form">
        <label className="add-mapping-modal-label">
          Field Mapping Name <span className="required">*</span>
        </label>
        <input
          type="text"
          className={`add-mapping-modal-input ${errorMessage ? "error" : ""}`}
          placeholder="Enter mapping name"
          value={newName}
          onChange={handleNameChange}
          maxLength={39}
          autoFocus
        />
        {errorMessage && (
          <span className="add-mapping-modal-error">{errorMessage}</span>
        )}
      </div>

      <div className="add-mapping-modal-buttons">
        <button className="add-mapping-modal-cancel" onClick={onClose}>
          Cancel
        </button>
        <button
          className="add-mapping-modal-confirm"
          onClick={handleConfirm}
          disabled={!isNameValid}
        >
          Save
        </button>
      </div>
    </PopupWin>
  );
};

export default AddMappingModal;
